import axios from '@/libs/api.request'

export const getSensitiveWordList = (page, limit, key) => {
  return axios.request({
    url: '/v1/system/security-sensitive-word/',
    method: 'get',
    params: {
      page,
      limit,
      key: key
    }
  })
}

export const operationSensitiveWord = (data, meth) => {
  return axios.request({
    url: '/v1/system/security-sensitive-word/',
    method: meth,
    data
  })
}